import { inject, onBeforeUnmount, onMounted } from 'vue';

export default function onAppEvent(eventName, callback) {
  /**
   * @constant
   * @type {EventTarget}
   */
  const eventTarget = inject('eventTarget');

  onMounted(() => {
    eventTarget.addEventListener(eventName, callback, false);
  });

  onBeforeUnmount(() => {
    eventTarget.removeEventListener(eventName, callback);
  });
}
